import { useMemo } from "react";
import { useAnalyticsContext } from "../BricksProvider";
const useObservabilitySafe = () => {
  const { useObservability } = useAnalyticsContext(), { trackJourneyEvent: actualTrackJourneyEvent } = useObservability(), trackJourneyEvent = useMemo(
    () => (categoryName, eventName, eventData, options) => {
      try {
        actualTrackJourneyEvent(categoryName, eventName, eventData, options);
      } catch {
      }
    },
    [actualTrackJourneyEvent]
  );
  return useMemo(
    () => ({
      trackJourneyEvent
    }),
    [trackJourneyEvent]
  );
};
export {
  useObservabilitySafe
};
